import { render, staticRenderFns } from "./DevPanel.vue?vue&type=template&id=15d3d289&scoped=true"
import script from "./DevPanel.vue?vue&type=script&lang=js"
export * from "./DevPanel.vue?vue&type=script&lang=js"
import style0 from "./DevPanel.vue?vue&type=style&index=0&id=15d3d289&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d3d289",
  null
  
)

export default component.exports